<template>
  <div class="login-page">
  <div class="user-auth-container">
    <div class="auth-sky" aria-hidden="true"></div>
    <div class="auth-stars" aria-hidden="true"></div>
    <div class="auth-vignette" aria-hidden="true"></div>

    <div class="auth-wrap">
      <div class="auth-topbar">
        <div class="brand">
          <div class="brand-block"></div>
          <div class="brand-text">
            <div class="brand-title">云边小镇</div>
            <div class="brand-subtitle">PLAYER LOGIN</div>
          </div>
        </div>
      </div>

      <div class="login-home-pill-wrapper">
        <a class="login-home-pill" href="/index">
          <span class="pill-icon">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </span>
          <span class="pill-text">返回首页</span>
        </a>
      </div>

      <div class="auth-card">
        <div class="brand">
          <div class="brand-title">登录</div>
          <div class="brand-subtitle">（仅限小镇成员使用噢，欢迎加入我们！）</div>
        </div>

        <div class="tabs">
          <button class="tab" :class="{ active: mode === 'password' }" @click="mode = 'password'">昵称登录</button>
          <button class="tab" :class="{ active: mode === 'email' }" @click="mode = 'email'">邮箱验证码</button>
        </div>

        <div class="tab-panel" v-if="mode === 'password'">
          <div class="row">
            <label class="label">游戏昵称</label>
            <input class="mc-input" v-model.trim="nickname" @blur="validateNickname" @keyup.enter="loginPassword" placeholder="例如：Dear_Monster" />
            <div class="hint" v-if="nicknameHint">{{ nicknameHint }}</div>
          </div>

          <div class="row">
            <label class="label">密码</label>
            <input class="mc-input" v-model.trim="password" @blur="validatePassword" type="password" @keyup.enter="loginPassword" placeholder="请输入密码" />
            <div class="hint" v-if="passwordHint">{{ passwordHint }}</div>
          </div>

          <div class="row captcha-row">
            <div class="captcha-left">
              <label class="label">验证码</label>
              <input class="mc-input" v-model.trim="captchaInput" @keyup.enter="loginPassword" placeholder="请输入验证码" />
            </div>
            <button class="captcha-chip" type="button" @click="refreshCaptcha" :disabled="captchaLoading">
              <span class="chip-title">{{ captchaLoading ? '加载中...' : captcha }}</span>
              <span class="chip-sub">点击刷新</span>
            </button>
          </div>

          <div class="row" style="margin-top: 28px;">
            <button class="mc-btn mc-btn-primary" @click="loginPassword" :disabled="loading">{{ loading ? '登录中...' : '登录' }}</button>
          </div>
        </div>

        <div class="tab-panel" v-else>
          <div class="row">
            <label class="label">邮箱</label>
            <input class="mc-input" v-model.trim="email" @blur="validateEmail" @keyup.enter="loginEmail" placeholder="请输入邮箱" />
            <div class="hint" v-if="emailHint">{{ emailHint }}</div>
          </div>

          <div class="row code-row">
            <div class="code-left">
              <label class="label">邮箱验证码</label>
              <input class="mc-input" v-model.trim="emailCode" @keyup.enter="loginEmail" placeholder="请输入邮箱验证码" />
            </div>
            <button class="mc-btn mc-btn-primary code-send" type="button" @click="sendLoginCode" :disabled="sending || countdown > 0 || !email">
              {{ sending ? '发送中...' : countdown > 0 ? `${countdown}s` : '发送验证码' }}
            </button>
          </div>

          <div class="row" style="margin-top: 28px;">
            <button class="mc-btn mc-btn-primary" @click="loginEmail" :disabled="loading">{{ loading ? '登录中...' : '登录' }}</button>
          </div>
        </div>

        <div class="row actions">
          <a class="link" href="/register">注册</a>
          <a class="link" href="/forgot">忘记密码</a>
        </div>

        <div v-if="error" class="error">{{ error }}</div>
        <div v-if="reasonFromKick" class="error">{{ reasonFromKick }}</div>
      </div>

      <div class="auth-ground" aria-hidden="true">
        <div class="grass"></div>
        <div class="dirt"></div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import { API_BASE } from '../config/apiBase'

// API_BASE moved to @/config/apiBase


export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter()
    const route = useRoute()

    const mode = ref('password')

    const nickname = ref('')
    const password = ref('')
    const captcha = ref('----')
    const captchaInput = ref('')
    const captchaLoading = ref(false)

    const email = ref('')
    const emailCode = ref('')

    const nicknameHint = ref('')
    const passwordHint = ref('')
    const emailHint = ref('')

    const error = ref('')
    const loading = ref(false)

    const sending = ref(false)
    const countdown = ref(0)
    let timer = null

    const reasonFromKick = ref('')

    const isEmail = (v) => /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/.test(v || '')
    const isNick = (v) => /^[A-Za-z0-9_]{3,16}$/.test(v || '')

    const validateNickname = () => {
      if (!nickname.value) {
        nicknameHint.value = '请输入游戏昵称'
        return false
      }
      if (!isNick(nickname.value)) {
        nicknameHint.value = '昵称仅英文/数字/下划线，3-16位'
        return false
      }
      nicknameHint.value = ''
      return true
    }

    const validatePassword = () => {
      if (!password.value) {
        passwordHint.value = '请输入密码'
        return false
      }
      if (password.value.length < 8) {
        passwordHint.value = '密码至少8位'
        return false
      }
      passwordHint.value = ''
      return true
    }

    const validateEmail = () => {
      if (!email.value) {
        emailHint.value = '请输入邮箱'
        return false
      }
      if (!isEmail(email.value)) {
        emailHint.value = '邮箱格式不正确'
        return false
      }
      emailHint.value = ''
      return true
    }

    const refreshCaptcha = async () => {
      captchaLoading.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/generateCaptcha`)
        const data = await res.json()
        if (data && data.code === 200) {
          captcha.value = data.captcha
        }
      } catch (e) {
        // ignore
      } finally {
        captchaLoading.value = false
      }
    }

    const startCountdown = () => {
      countdown.value = 60
      if (timer) clearInterval(timer)
      timer = setInterval(() => {
        countdown.value -= 1
        if (countdown.value <= 0) {
          clearInterval(timer)
          timer = null
        }
      }, 1000)
    }

    const sendLoginCode = async () => {
      error.value = ''
      if (!validateEmail()) return
      if (countdown.value > 0) return
      sending.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/sendEmailCode`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email.value, scene: 'login' })
        })
        const data = await res.json()
        if (data && data.code === 200) {
          startCountdown()
        } else {
          error.value = (data && data.message) || '发送失败'
        }
      } catch (e) {
        error.value = '发送失败'
      } finally {
        sending.value = false
      }
    }

    const persistLogin = (data) => {
      localStorage.setItem('user_token', data.token)

      const now = new Date().toISOString()
      const existingRaw = localStorage.getItem('user_profile')
      let existing = {}
      try {
        existing = existingRaw ? JSON.parse(existingRaw) : {}
      } catch (e) {
        existing = {}
      }

      localStorage.setItem(
        'user_profile',
        JSON.stringify({
          userId: data.userId,
          nickname: data.nickname,
          email: data.email,
          avatarUrl: data.avatarUrl || '',
          registeredAt: existing.registeredAt || now
        })
      )
    }

    const loginPassword = async () => {
      error.value = ''
      if (!validateNickname() || !validatePassword()) return
      if (!captchaInput.value) {
        error.value = '请输入验证码'
        return
      }
      loading.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/login-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nickname: nickname.value,
            password: password.value,
            captcha: captcha.value,
            captchaInput: captchaInput.value
          })
        })
        const data = await res.json()
        if (data && data.code === 200 && data.token) {
          persistLogin(data)
          router.replace('/index')
        } else {
          error.value = (data && data.message) || '登录失败'
          await refreshCaptcha()
        }
      } catch (e) {
        error.value = '登录失败'
      } finally {
        loading.value = false
      }
    }

    const loginEmail = async () => {
      error.value = ''
      if (!validateEmail()) return
      if (!emailCode.value) {
        error.value = '请输入邮箱验证码'
        return
      }
      loading.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/login-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email.value, code: emailCode.value })
        })
        const data = await res.json()
        if (data && data.code === 200 && data.token) {
          persistLogin(data)
          router.replace('/index')
        } else {
          error.value = (data && data.message) || '登录失败'
        }
      } catch (e) {
        error.value = '登录失败'
      } finally {
        loading.value = false
      }
    }

    onMounted(async () => {
      const reason = route.query.reason
      if (typeof reason === 'string' && reason) {
        reasonFromKick.value = reason
      }
      await refreshCaptcha()
    })

    onUnmounted(() => {
      if (timer) clearInterval(timer)
    })

    return {
      mode,
      nickname,
      password,
      captcha,
      captchaInput,
      captchaLoading,
      email,
      emailCode,
      nicknameHint,
      passwordHint,
      emailHint,
      error,
      loading,
      sending,
      countdown,
      reasonFromKick,
      validateNickname,
      validatePassword,
      validateEmail,
      refreshCaptcha,
      sendLoginCode,
      loginPassword,
      loginEmail
    }
  }
}
</script>

<style>
@import '../styles/auth-mc.css';

/* 登录页卡片化布局 - 仅影响本页面 */
.login-page .user-auth-container {
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 100vh;
}

.login-page .auth-wrap {
  width: 100%;
  max-width: 640px;
  min-height: auto;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login-page .auth-topbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
  width: 100%;
  padding: 16px 18px 10px;
}

.login-page .login-home-pill-wrapper {
  position: fixed;
  top: 22px;
  right: 22px;
  z-index: 200;
}

.login-page .login-home-pill {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 10px 18px;
  border: 3px solid #000;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow:
    inset -3px -3px 0 rgba(0, 0, 0, 0.5),
    inset 3px 3px 0 rgba(255, 255, 255, 0.1),
    0 12px 30px rgba(0, 0, 0, 0.6);
  color: #fff;
  text-decoration: none;
  font-weight: 900;
  font-size: 13px;
  letter-spacing: 1.5px;
  user-select: none;
  transform: translateZ(0);
  transition: all 160ms ease;
  position: relative;
  /* 严格限制溢出，防止扫光突出 */
  overflow: hidden;
  border-radius: 4px;
}

/* 优化后的高级扫光：双重灵动光束 */
.login-page .login-home-pill::before {
  content: '';
  position: absolute;
  top: 0;
  left: -150%;
  width: 80%;
  height: 100%;
  /* 双光束渐变 */
  background: linear-gradient(
    105deg, 
    transparent 20%, 
    rgba(154, 224, 84, 0.05) 40%, 
    rgba(154, 224, 84, 0.3) 50%, 
    rgba(154, 224, 84, 0.05) 60%, 
    transparent 80%
  );
  transform: skewX(-30deg);
  pointer-events: none;
}

.login-page .login-home-pill:hover::before {
  animation: pillSweep 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes pillSweep {
  0% { left: -150%; opacity: 0; }
  20% { opacity: 1; }
  80% { opacity: 1; }
  100% { left: 150%; opacity: 0; }
}

.login-page .login-home-pill .pill-text {
  color: #ffffff !important;
  text-shadow: 2px 2px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;
  display: inline-block !important;
  white-space: nowrap;
}


.login-page .login-home-pill .pill-icon {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #000;
  background: rgba(20, 20, 20, 0.9);
  box-shadow: inset -2px -2px 0 rgba(0,0,0,0.5), inset 2px 2px 0 rgba(255,255,255,0.08);
  color: #9ae054;
}

.login-page .login-home-pill:hover {
  transform: translateY(-2px);
  filter: brightness(1.06);
  border-color: rgba(94, 168, 24, 0.9);
  box-shadow:
    inset -3px -3px 0 rgba(0, 0, 0, 0.42),
    inset 3px 3px 0 rgba(255, 255, 255, 0.10),
    0 18px 44px rgba(0, 0, 0, 0.55),
    0 0 26px rgba(94, 168, 24, 0.25);
}

.login-page .login-home-pill:active {
  transform: translateY(0px);
  filter: brightness(0.98);
}

@media (max-width: 768px) {
  .login-page .login-home-pill-wrapper {
    top: 14px;
    right: 14px;
  }
  .login-page .login-home-pill {
    padding: 9px 12px;
  }
}

.login-page .auth-card {
  background: rgba(0, 0, 0, 0.94);
  border: 8px solid #5a5a5a;
  border-radius: 12px;
  padding: 60px 50px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.9), inset 0 0 0 2px rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.login-page .auth-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 8px;
  background: linear-gradient(90deg, var(--mc-green) 0%, #9ae054 50%, var(--mc-green) 100%);
  border-bottom: 3px solid #3c6b10;
}

.login-page .auth-card::after {
  content: '';
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
}

.login-page .auth-ground {
  display: none;
}

.login-page .brand {
  text-align: center;
  margin-bottom: 30px;
}

.login-page .brand-title {
  font-size: 36px;
  color: #fff;
  text-shadow: 6px 6px 0 #000;
  margin-bottom: 8px;
  letter-spacing: 2px;
}

.login-page .brand-subtitle {
  font-size: 14px;
  color: var(--mc-green);
  letter-spacing: 3px;
  text-shadow: 2px 2px 0 #000;
}

/* 标签页 */
.login-page .tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 20px;
}

.login-page .tab {
  padding: 12px 16px;
  border: 3px solid #000;
  background: #3a3a3a;
  color: #fff;
  font-weight: 800;
  letter-spacing: 1px;
  box-shadow: inset -3px -3px 0 rgba(0,0,0,0.35), inset 3px 3px 0 rgba(255,255,255,0.1);
  cursor: pointer;
  transition: all 0.2s ease;
}

.login-page .tab.active {
  background: var(--mc-green);
  box-shadow: inset -3px -3px 0 #3c6b10, inset 3px 3px 0 #9ae054;
}

.login-page .tab:hover:not(.active) {
  background: #4a4a4a;
}

/* 验证码行 */
.login-page .captcha-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: end;
}

.login-page .captcha-chip {
  border: 3px solid #000;
  background: #0f0f10;
  color: #fff;
  padding: 12px 16px;
  box-shadow: inset -3px -3px 0 rgba(0,0,0,0.45), inset 3px 3px 0 rgba(255,255,255,0.06);
  cursor: pointer;
  min-width: 140px;
  text-align: center;
  transition: all 0.2s ease;
}

.login-page .captcha-chip:hover {
  background: #1a1a1b;
}

.login-page .chip-title {
  display: block;
  font-weight: 900;
  letter-spacing: 4px;
  font-size: 16px;
  color: #9ae054;
  text-shadow: 2px 2px 0 #000;
}

.login-page .chip-sub {
  display: block;
  margin-top: 2px;
  font-size: 10px;
  color: rgba(255,255,255,0.55);
}

/* 主按钮：居中拉长，适配卡片 */
.login-page .auth-card .mc-btn.mc-btn-primary {
  display: block;
  width: min(420px, 100%);
  margin: 0 auto;
  padding: 14px 18px;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 2px;
}

/* 邮箱验证码发送按钮：保持在右侧，不被“主按钮”样式影响 */
.login-page .auth-card .mc-btn.mc-btn-primary.code-send {
  width: auto;
  margin: 0;
  padding: 12px 16px;
  font-size: 12px;
  letter-spacing: 1px;
}

/* 操作链接 */
.login-page .actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid rgba(255,255,255,0.1);
}

.login-page .link {
  color: var(--mc-green);
  text-decoration: none;
  font-size: 14px;
  font-weight: 800;
  padding: 6px 10px;
  transition: color 0.2s ease;
}

.login-page .link:hover {
  color: #9ae054;
}

/* 错误提示 */
.login-page .error {
  background: rgba(231, 76, 60, 0.1);
  border: 2px solid #e74c3c;
  color: #e74c3c;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 16px;
  text-align: center;
}

/* 响应式 */
@media (max-width: 768px) {
  .login-page .user-auth-container {
    padding: 20px 15px;
  }

  .login-page .auth-card {
    padding: 40px 30px;
  }

  .login-page .brand-title {
    font-size: 28px;
  }

  .login-page .brand-subtitle {
    font-size: 12px;
  }
}

@media (max-width: 560px) {
  .login-page .user-auth-container {
    padding: 15px 10px;
  }

  .login-page .auth-card {
    padding: 30px 20px;
  }

  .login-page .brand-title {
    font-size: 24px;
  }

  .login-page .captcha-row {
    grid-template-columns: 1fr;
  }

  .login-page .captcha-chip {
    width: 100%;
    min-width: auto;
  }

  .login-page .actions {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }
}
</style>

